import { Box, Heading, Text, List, ListItem, Table, Thead, Tr, Th, Td, Tbody } from '@chakra-ui/react';
import {DayWiseRecord, MarketScanFormData} from '../Constants/type';
import {useAppSelector} from '../Hooks/useAppSelector';
import {selectMarketScanRecord} from '../Redux/MarketScanSlice';

const MarketScanDetails = () => {
  let record:MarketScanFormData=useAppSelector(selectMarketScanRecord);
  return (
    <Box p={4}>
      <Heading as="h1" mb={4}>
        Market Scan Record Details
      </Heading>
      <List spacing={3}>
        <ListItem>
          <Text fontWeight="bold">Visited At:</Text>
          <Text>{record.visited_at}</Text>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Address:</Text>
          <Text>{record.address}</Text>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Shop Name:</Text>
          <Text>{record.shop_name}</Text>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Shop Size:</Text>
          <Text>{record.shop_size}</Text>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Landmarks:</Text>
          <List styleType="disc">
            {record.landmarks.map((landmark:string, index:number) => (
              <ListItem listStyleType="none" key={index}>{landmark}</ListItem>
            ))}
          </List>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Area Description:</Text>
          <Text>{record.area_description}</Text>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Road Description:</Text>
          <Text>{record.road_description}</Text>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Product Categories:</Text>
          <List styleType="disc">
            {record.product_categories.map((category:string, index:number) => (
              <ListItem listStyleType={"none"} key={index}>{category}</ListItem>
            ))}
          </List>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Visit Status:</Text>
          <Table variant="simple" size="sm">
            <Thead>
              <Tr>
                <Th>Timestamp</Th>
                <Th>Value</Th>
              </Tr>
            </Thead>
            <Tbody>
              {record.visit_status.map((entry:any, index:number) => (
                <Tr key={index}>
                  <Td>{entry.timeStamp}</Td>
                  <Td>
                    {Array.isArray(entry.val) ? entry.val.join(', ') : entry.val}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Decision Makers:</Text>
          <Text>{record.decision_makers}</Text>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Influencers:</Text>
          <Text>{record.influencers}</Text>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Conversion Chances:</Text>
          <Table variant="simple" size="sm">
            <Thead>
              <Tr>
                <Th>Timestamp</Th>
                <Th>Value</Th>
              </Tr>
            </Thead>
            <Tbody>
              {record.conversion_chances.map((entry:any, index:any) => (
                <Tr key={index}>
                  <Td>{entry.timeStamp}</Td>
                  <Td>{entry.val}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Openness:</Text>
          <Table variant="simple" size="sm">
            <Thead>
              <Tr>
                <Th>Timestamp</Th>
                <Th>Value</Th>
              </Tr>
            </Thead>
            <Tbody>
              {record.openness.map((entry:DayWiseRecord, index:any) => (
                <Tr key={index}>
                  <Td>{entry.timeStamp}</Td>
                  <Td>{entry.val}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Ownership:</Text>
          <Text>{record.ownership}</Text>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Owner Name:</Text>
          <Text>{record.owner_name}</Text>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Contact Number:</Text>
          <Text>{record.contact_number}</Text>
        </ListItem>
        <ListItem>
          <Text fontWeight="bold">Notes:</Text>
          <Table variant="simple" size="sm">
            <Thead>
              <Tr>
                <Th>Timestamp</Th>
                <Th>Value</Th>
              </Tr>
            </Thead>
            <Tbody>
              {record.notes.map((entry:DayWiseRecord, index:any) => (
                <Tr key={index}>
                  <Td>{entry.timeStamp}</Td>
                  <Td>{entry.val}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </ListItem>
      </List>
    </Box>
  );
};

export default MarketScanDetails;
